import { createApp } from 'vue'
import moment from 'moment'
import App from './App'
import router from '@/router'
import store from '@/store'
import aos from 'aos'

import '@/_core/styles/reset.css'
import '@/assets/styles/general.sass'
import 'aos/dist/aos.css'

import { init as initFetcherFunction } from '@/_core/api/apiWrapper'
import {
  API_BASE_URL,
  AUTH_TOKEN_NAME,
  DISABLE_RIGHT_CLICK
} from '@/config'

import initializeUiKit from '@/components/_ui'

moment.locale('ru')

initFetcherFunction({ apiBaseUrl: API_BASE_URL, authTokenName: AUTH_TOKEN_NAME })

moment.locale('ru')

const app = createApp(App)

initializeUiKit(app)

app
  .use(router)
  .provide('store', store)
  .mount('#app')

aos.init({
  duration: 500
})

if (DISABLE_RIGHT_CLICK) {
  document.body.oncopy = function () { return false }
  document.body.oncut = function () { return false }
  document.body.oncontextmenu = function () { return false }
}
